<template>
  <div class="pagination">
    <div class="v-datatable__actions__range-controls">
      <div class="v-datatable__actions__pagination">{{ from }}-{{ to }} of {{ formatNumber(total) }}</div>
      <button type="button" class="v-btn v-btn--flat v-btn--icon theme--light" :class="{ disabled: (value || 1) === 1 }" @click="emitInput(-1)">
        <div class="v-btn__content">
          <v-icon>mdi-chevron-left</v-icon>
        </div>
      </button>
      <button type="button" class="v-btn v-btn--flat v-btn--icon theme--light" :class="{ disabled: (value || 1) === totalPages }" @click="emitInput(1)">
        <div class="v-btn__content">
          <v-icon>mdi-chevron-right</v-icon>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral';

export default {
  noExport: true,
  props: ['value', 'perPage', 'total'],
  data() {
    return {
      lastTop: null,
    };
  },
  computed: {
    from() {
      return ((this.value || 1) - 1) * (this.perPage || 15) + 1;
    },
    to() {
      return Math.min(this.from + (this.perPage || 15) - 1, this.total);
    },
    totalPages() {
      return Math.ceil(this.total / this.perPage);
    },
  },
  methods: {
    formatNumber(num) {
      return numeral(num).format('0,0');
    },
    emitInput(delta) {
      this.lastTop = this.$el.getBoundingClientRect().top;

      var value = (this.value || 1) + delta;
      this.$emit('input', value);
    },
    scrollToLastPosition() {
      if (this.lastTop) {
        var newTop = this.$el.getBoundingClientRect().top;
        window.scrollBy(0, newTop - this.lastTop);
      }
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisPagination'] = this;
  },
}
</script>

<style lang="scss">
.pagination {
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
</style>